import $ from "jquery";
import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Articles extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;
        if (!Context.IsLogged()) {
            return;
        }
        var sid = Context.GetContext().Sid;

        var articles = Comm.Articles(sid, false);

        this.state = {
            Articles: articles,
            SelectedArticle: null,
            showMissingCodeError: false,
            showMissingNameError: false,
        };

        this.ShowHidePack = this.ShowHidePack.bind(this);
        this.NewArticle = this.NewArticle.bind(this);
        this.Save = this.Save.bind(this);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        var articles = this.state.Articles.slice();

        var self = this;

        return Context.HasRight("rarticles") === true ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("articles")}</div>
                <div className="panel-body">
                    {Context.HasRight("earticles") ? (
                        <button className="btn btn-primary" onClick={this.NewArticle}>
                            {Translation.Trans("newarticle")}
                        </button>
                    ) : null}
                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-5">
                            <div className="row">
                                <div className="col-lg-4 col-md-8">{Translation.Trans("code")}</div>
                                <div className="col-lg-4 col-md-4">{Translation.Trans("inputarticle")}</div>
                            </div>
                            <div className="scrollableDiv">
                                {articles.map((obj) => (
                                    <div className="row">
                                        <div className="col-lg-4 col-md-8">
                                            <span
                                                className={
                                                    this.state.SelectedArticle != null &&
                                                        this.state.SelectedArticle.id === obj.id
                                                        ? "btn btn-warning"
                                                        : null
                                                }
                                            >
                                                <a
                                                    onClick={() => self.EditArticle(obj)}
                                                    className="pointhand"
                                                >
                                                    {obj.code}
                                                </a>
                                            </span>
                                        </div>
                                        <div className="col-lg-4 col-md-4">
                                            {obj.is_input ? (
                                                <i className="fa fa-check" aria-hidden="true"></i>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {this.state.SelectedArticle !== null ? (
                            <div className="col-md-7 borderDiv">
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("code")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input
                                            type="text"
                                            id="tbCode"
                                            className="form-control"
                                            defaultValue={this.state.SelectedArticle.code}
                                            key={"code" + this.state.SelectedArticle.id}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.showMissingCodeError ? (
                                            <div className="alert alert-danger">
                                                {Translation.Trans("entervalue")}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("name")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input
                                            type="text"
                                            id="tbName"
                                            className="form-control"
                                            defaultValue={this.state.SelectedArticle.name}
                                            key={"name" + this.state.SelectedArticle.id}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.showMissingNameError ? (
                                            <div className="alert alert-danger">
                                                {Translation.Trans("entervalue")}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <label className="control-label">
                                            {Translation.Trans("inputarticle")}
                                        </label>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="checkbox">
                                            <input
                                                id="cbInput"
                                                type="checkbox"
                                                defaultChecked={this.state.SelectedArticle.is_input}
                                                key={"input" + this.state.SelectedArticle.id}
                                            />
                                            <label htmlFor="cbInput"></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="checkbox">
                                            <input
                                                id="cbTrackPack"
                                                type="checkbox"
                                                onClick={this.ShowHidePack}
                                                defaultChecked={this.state.SelectedArticle.tracking !== null}
                                                key={"trackpack" + this.state.SelectedArticle.id}
                                            />
                                            <label htmlFor="cbTrackPack">
                                                {Translation.Trans("trackpack")}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div
                                        className="col-md-10 pull-right"
                                        style={{
                                            visibility:
                                                this.state.SelectedArticle.tracking !== null
                                                    ? "visible"
                                                    : "hidden",
                                        }}
                                    >
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label className="control-label">
                                                    {Translation.Trans("packweight")}
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <input
                                                    type="number"
                                                    id="tbPackWeight"
                                                    className="form-control"
                                                    defaultValue={
                                                        this.state.SelectedArticle.tracking === null
                                                            ? "0"
                                                            : this.state.SelectedArticle.tracking
                                                                .packet_weight
                                                    }
                                                    key={"packweight" + this.state.SelectedArticle.id}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label className="control-label">
                                                    {Translation.Trans("bagweight")}
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <input
                                                    type="number"
                                                    id="tbBagWeight"
                                                    className="form-control"
                                                    defaultValue={
                                                        this.state.SelectedArticle.tracking === null
                                                            ? "0"
                                                            : this.state.SelectedArticle.tracking.sack_to
                                                    }
                                                    key={"bagweight" + this.state.SelectedArticle.id}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="checkbox">
                                            <input
                                                id="cbIsShoe"
                                                type="checkbox"
                                                defaultChecked={this.state.SelectedArticle.is_shoe}
                                                key={"isShoe" + this.state.SelectedArticle.id}
                                            />
                                            <label htmlFor="cbIsShoe">{Translation.Trans("isshoe")}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="checkbox">
                                            <input
                                                id="cbVisible"
                                                type="checkbox"
                                                defaultChecked={this.state.SelectedArticle.visible}
                                                key={"visible" + this.state.SelectedArticle.id}
                                            />
                                            <label htmlFor="cbVisible">{Translation.Trans("visible")}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {Context.HasRight("earticles") ? (
                                        <div className="col-md-12">
                                            <button
                                                className="btn btn-primary pull-right"
                                                onClick={this.Save}
                                            >
                                                {Translation.Trans("save")}
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }

    EditArticle(article) {
        this.setState({ SelectedArticle: article });
    }
    NewArticle() {
        this.setState({ SelectedArticle: { tracking: null, visible: true, is_shoe: false } });
    }

    ShowHidePack() {
        var article = this.state.SelectedArticle;
        var checked = $("#cbTrackPack").prop("checked");
        if (checked)
            article.tracking = {
                packet_weight: 0,
                sack_to: 0,
            };
        else article.tracking = null;
        this.setState({ SelectedArticle: article });
    }

    Save() {
        this.setState({ showMissingCodeError: false, showMissingNameError: false });
        var canSave = true;
        var code = $("#tbCode").val();
        var name = $("#tbName").val();
        var inp = $("#cbInput").prop("checked");
        var tp = $("#cbTrackPack").prop("checked");
        var visible = $("#cbVisible").prop("checked");
        var pw = $("#tbPackWeight").val();
        var bw = $("#tbBagWeight").val();
        var is_shoe = $("#cbIsShoe").prop("checked");

        if (code === "") {
            this.setState({ showMissingCodeError: true });
            canSave = false;
        }

        if (name === "") {
            this.setState({ showMissingNameError: true });
            canSave = false;
        }

        if (!canSave) return;

        var data = {};
        if (this.state.SelectedArticle.hasOwnProperty("id")) {
            data.id = this.state.SelectedArticle.id;
            data.qty = this.state.SelectedArticle.qty;
        } else {
            data.qty = 0;
        }
        data.visible = visible;
        data.name = name;
        data.code = code;
        data.is_input = inp;
        data.is_shoe = is_shoe;
        if (tp) {
            data.tracking = JSON.stringify({ packet_weight: pw, sack_to: bw });
        }
        var sid = Context.GetContext().Sid;
        data.session = sid;

        Comm.SaveArticle(data);

        var articles = Comm.Articles(sid, false);

        this.setState({
            Articles: articles,
            SelectedArticle: null,
            showMissingCodeError: false,
            showMissingNameError: false,
        });
    }

    Del() {
        if (window.confirm(Translation.Trans("pleaseconfirm"))) {

            var data = this.state.SelectedArticle;
            var sid = Context.GetContext().Sid;
            data.session = sid;
            data.visible = false;
            Comm.SaveArticle(data);
            this.setState({ SelectedArticle: null });
        }

        //павката не ми го е дал
    }
}

export default Articles;



// WEBPACK FOOTER //
// ./src/pages/articles.js